import { Injectable } from '@angular/core';
import { SwapIface } from '../interfaces/swap.iface';
import { OfferIface } from '../interfaces/offer.iface';
import { SelectedOffer } from '../interfaces/selected-offer.model';
import { isEqual, differenceWith, uniq } from 'lodash';

@Injectable()
export class OffersMassEditionService {
  private _originalOffers: OfferIface[] = [];
  private _modifiedOffersIds: string[] = [];
  private _multipleSwaps: SwapIface[] = [];
  private _selectedOffers: SelectedOffer[] = [];
  private _taggedOffers: OfferIface[] = [];

  get originalOffers() {
    return this._originalOffers;
  }
  set originalOffers(offers: OfferIface[]) {
    this._originalOffers = offers;
  }
  get modifiedOffersIds() {
    return this._modifiedOffersIds;
  }
  set modifiedOffersIds(offersIds: string[]) {
    this._modifiedOffersIds = offersIds;
  }
  get multipleSwaps() {
    return this._multipleSwaps;
  }
  set multipleSwaps(swaps: SwapIface[]) {
    this._multipleSwaps = swaps;
  }
  get selectedOffers() {
    return this._selectedOffers;
  }
  set selectedOffers(ids: SelectedOffer[]) {
    this._selectedOffers = ids;
  }
  get taggedOffers() {
    return this._taggedOffers;
  }
  set taggedOffers(ids: OfferIface[]) {
    this._taggedOffers = ids;
  }

  constructor() {}

  isAllSelected(): boolean {
    return !this._selectedOffers.some(offer => offer.selected === false);
  }

  isOfferSelected(id: string): boolean {
    const selectedOffer = this._selectedOffers.find(offer => offer.id === id);
    return selectedOffer ? selectedOffer.selected : false;
  }

  selectOffer(id: string): void {
    this._selectedOffers.find(offer => offer.id === id).select();
  }

  selectAllOffers(): void {
    this.selectedOffers.forEach(offer => {
      offer.selected = true;
    });
  }

  clearAllOffers(): void {
    this.selectedOffers.forEach(offer => {
      offer.selected = false;
    });
  }

  updateModifiedOffersIds(): void {
    this._modifiedOffersIds = uniq(
      this._multipleSwaps.reduce((ids, swap) => {
        return [...ids, ...swap.offersIds];
      }, [])
    );
  }

  modifyOffers(offers: any[]): any[] {
    this._multipleSwaps.forEach(swap => {
      if (swap.isToggled) {
        offers = offers.map(offer => {
          if (swap.offersIds.includes(offer['_id'])) {
            swap.activeInputs.forEach(input => {
              offer[input.propertyName] = input.value;
            });
          }
          return offer;
        });
      }
    });
    return offers;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/offers-mass-edition.service.ts